function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "15",
  height: "15",
  viewBox: "0 0 15 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M4.464 10.032a4 4 0 105.657-5.657",
  stroke: "#12002D",
  strokeWidth: "1.5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.535 2.961H8.707V5.79",
  fill: "#12002D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.535 2.961H8.707V5.79l2.828-2.829z",
  stroke: "#12002D",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.879 8.618H3.05v2.828",
  fill: "#12002D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.879 8.618H3.05v2.828L5.88 8.618z",
  stroke: "#12002D",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));